import { Logger as d, ConfigService as R, request as A } from "@nextgen-web-framework/core";
import { getContentReqObj as m, getLivePreviewReqObj as L, getPageReqObj as I } from "../../config/cmsEndPoints.js";
import h from "./referenceMapping.js";
import { request as P } from "./fetchRequest.js";
const i = d.getInstance(), g = (r, e, c, t) => {
  let n = "";
  if (r || e) {
    let a = `${t ? "&" : "?"}references=`;
    r && (a += r), e && (a += `,${e}`), n += a;
  }
  if (c != null && c.length) {
    let a = "";
    a = c.map(
      (l, f) => `${f === 0 && !(r || e) ? "?" : "&"}${l.key}=${l.value}`
    ).join(""), n += a;
  }
  return n;
}, E = async (r, e) => {
  const c = R.getConfigs();
  e != null && e.headers && (r.headers = e == null ? void 0 : e.headers), e != null && e.baseURL && (r.url = `${e.baseURL}${r.url}`);
  const t = c.NEXT_REQUEST_VERSION_V2 ? await A(r) : await P(r);
  return Promise.resolve(t);
}, y = (r, e) => {
  const c = R.getConfigs(), t = `${e ? "&" : "?"}stack=dev`;
  return c.NEXT_STACK_DEV_ENABLE ? `${r}${e}${t}` : `${r}${e}`;
}, U = {
  async fetchContent({ uId: r, params: e, includeCount: c }, t) {
    const n = await this.fetchAllContent({ uId: r, params: e, includeCount: c }, t);
    return Array.isArray(n) ? (n == null ? void 0 : n.length) > 0 ? n[0] : {} : n;
  },
  async fetchAllContent({ uId: r, params: e, includeCount: c }, t, n = !0) {
    try {
      const a = h[r], { uId: l, references: f = "", references_groups: o = "" } = a, s = m({
        uId: l
      }), $ = n ? g(f, o, e) : g("", "", e);
      s.url = y(s.url, $), i.info("cms CONTENT SDK URL - ", s.url);
      const u = await E(s, t);
      return c ? { data: u == null ? void 0 : u.data, count: u == null ? void 0 : u.count } : u == null ? void 0 : u.data;
    } catch (a) {
      throw i.error("cms CONTENT SDK FAILURE - ", a), a;
    }
  },
  async fetchLivePreview({ contentType: r, hash: e, entryId: c, params: t }, n) {
    try {
      const a = h[r], { uId: l, references: f = "", references_groups: o = "" } = a, s = L({
        contentType: l,
        hash: e,
        entryId: c
      }), $ = g(f, o, t, !0);
      return s.url = y(s.url, $), i.info("cms LIVE PREVIEW SDK URL - ", s.url), await E(s, n);
    } catch (a) {
      throw i.error("cms LIVE PREVIEW SDK FAILURE - ", a), a;
    }
  },
  async fetchPage({ slug: r, template: e }, c) {
    const t = await this.fetchAllPages({ slug: r, template: e }, c);
    return Array.isArray(t) ? t.length > 0 ? t[0] : {} : t;
  },
  async fetchAllPages({ slug: r, template: e }, c) {
    try {
      const t = I({
        slug: r
      });
      if (e) {
        const a = h[e], { uId: l, references: f = "", references_groups: o = "" } = a;
        t.url = `${t.url}?template=${l}`;
        const s = g(f, o, void 0, !0);
        t.url = y(t.url, s);
      }
      const n = await E(t, c);
      return i.info("cms PAGE SDK URL - ", t.url), n == null ? void 0 : n.data;
    } catch (t) {
      throw i.error("cms PAGE SDK FAILURE - ", t), t;
    }
  }
};
export {
  U as cmsApi,
  g as getReferencesQuery
};
//# sourceMappingURL=cmsApi.js.map
